module.exports = __webpack_public_path__ + "img/logo_bspb.b5f702d1.jpg";